import { render, staticRenderFns } from "./SingleContact.vue?vue&type=template&id=af232222&scoped=true&"
import script from "./SingleContact.vue?vue&type=script&lang=js&"
export * from "./SingleContact.vue?vue&type=script&lang=js&"
import style0 from "./SingleContact.vue?vue&type=style&index=0&id=af232222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af232222",
  null
  
)

export default component.exports